import React, { useEffect, useState } from 'react';
import { stateOptions } from './constants';
import { useIframeHeight } from './hooks/useIframeHeight';
import { useFileUpload } from './hooks/useFileUpload';
import { useProgressMessage } from './hooks/useProgressMessage';
import {
  InstructionsPage,
  TermsOfUse,
  SelectStatePage,
  UploadDocumentPage,
  DisclaimerAcknowledgement,
  DisplayReport,
} from './components/steps';
import { SinglePageLayout } from './components/SinglePageLayout';

const USE_NEW_LAYOUT = true;

export default function Index() {
  const [step, setStep] = useState(1);
  const [selectedState, setSelectedState] = useState(stateOptions[0]);

  useIframeHeight();

  const fileUpload = useFileUpload();
  const isProcessing = fileUpload.status === 'uploading' || fileUpload.status === 'polling';
  const progressMessage = useProgressMessage(isProcessing);

  useEffect(() => {
    if (fileUpload.status === 'success' && step === 4) {
      setStep(5);
    }
  }, [fileUpload.status, step]);

  const handleStateChange = (option) => {
    setSelectedState(option);
  };

  const handleProcess = () => {
    if (fileUpload.file) {
      fileUpload.handleUpload(selectedState);
    }
  };

  const handleRestart = () => {
    setStep(1);
    setSelectedState(stateOptions[0]);
    fileUpload.reset();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (USE_NEW_LAYOUT) {
    return <SinglePageLayout fileUpload={fileUpload} progressMessage={progressMessage} />;
  }

  return (
    <div className="wrapper">
      {step === 1 && <InstructionsPage onContinue={() => setStep(2)} />}

      {step === 2 && <TermsOfUse onAgree={() => setStep(3)} onRestart={handleRestart} />}

      {step === 3 && (
        <SelectStatePage
          selectedState={selectedState}
          onSelectState={handleStateChange}
          onNext={() => setStep(4)}
          onRestart={handleRestart}
        />
      )}

      {step === 4 && (
        <UploadDocumentPage
          status={fileUpload.status}
          file={fileUpload.file}
          progressMessage={progressMessage}
          textInput={fileUpload.textInput}
          textUploaded={fileUpload.textUploaded}
          onFileChange={fileUpload.handleFileChange}
          onTextChange={fileUpload.handleTextChange}
          onTextSubmit={fileUpload.handleTextSubmit}
          onProcess={handleProcess}
          onRestart={handleRestart}
        />
      )}

      {step === 5 && (
        <DisclaimerAcknowledgement
          disclaimer={fileUpload.disclaimer}
          onAcknowledge={() => setStep(6)}
          onRestart={handleRestart}
        />
      )}

      {step === 6 && fileUpload.report && (
        <DisplayReport
          report={fileUpload.report}
          disclaimer={fileUpload.disclaimer}
          styledReport={fileUpload.styledReport}
          containsNDA={fileUpload.containsNDA}
          ndaReport={fileUpload.ndaReport}
          onRestart={handleRestart}
        />
      )}
    </div>
  );
}
